import Redeem from "../../components/Redeem"

const RedeemContainer = ({ setIsLoggedIn, headLess }) => (
  <Redeem setIsLoggedIn={setIsLoggedIn} headLess={headLess} />
);
export default RedeemContainer;